/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerEntity { 
    actualization?: boolean;
    birthDate?: string;
    conscriptionNumber: number;
    contractIdentifier: string;
    contractObject: string;
    contractSignatureDate: string;
    firstName?: string;
    freeCadastre?: boolean;
    hasCustomerContract?: boolean;
    ico?: string;
    id: number;
    municipality: string;
    name?: string;
    orientationNumber?: string;
    street: string;
    surname?: string;
    zipCode: string;
}

